import React, { Component } from "react";
import "./AboutMe.css";

class AboutMe extends Component {
  componentDidMount() {
    // Initialize Materialize collapsible
    const M = window.M;
    if (M) {
      M.Collapsible.init(document.querySelectorAll('.collapsible'));
    }
  }

  render() {
    return (
      <div className="pushin">
        <ul className="collapsible popout">
          <li>
            <div className="collapsible-header">ABOUT ME</div>
            <div className="collapsible-body center-align">
              <div>
                <span>
                  Greetings! I'm Ohad Katz, a Senior Systems Development Engineer at Amazon Web Services. 
                  I specialize in building and operating production cloud platforms at scale, with 6+ years 
                  of experience in AI/ML infrastructure, automated systems, and cloud technologies. 
                  Check out my resume and feel free to connect with me on LinkedIn.
                </span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    );
  }
}

export default AboutMe;
